import { FormField } from 'src/common/FormField';
import type {
  FormFieldControllerRulesProps} from 'src/common/FormField/FormFieldController';
import {
  FormFieldController
} from 'src/common/FormField/FormFieldController';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

const priceRoundingOptions: SelectOption[] = [
  {
    label: 'Do not round',
    value: 'none',
  },
  {
    label: 'Round up',
    value: 'up',
  },
  {
    label: 'Round down',
    value: 'down',
  },
  {
    label: 'Round to nearest',
    value: 'nearest',
  },
];

export function PriceRoundingSelectField({
  fieldPath,
  rules,
}: {
  fieldPath: string;
  rules?: FormFieldControllerRulesProps;
}) {
  return (
    <FormFieldController name={fieldPath} rules={rules}>
      {({ field, fieldState }) => {
        return (
          <FormField
            error={fieldState?.error?.message}
            label="Price Rounding"
            type="select"
            inputProps={{
              ...field,
              id: fieldPath,
            }}
            onChange={(option) => {
              field.onChange(option.value);
            }}
            options={priceRoundingOptions}
            value={
              field.value
                ? priceRoundingOptions.find(
                    (option) => option.value === field.value
                  )
                : 'none'
            }
            inline
            helperText="Choose how the final price should be rounded."
          />
        );
      }}
    </FormFieldController>
  );
}
